module.exports = __webpack_public_path__ + "static/media/T1.74f0143a.jpg";